import { bootstrapApplication } from '@angular/platform-browser';
import * as Sentry from '@sentry/angular';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { environment } from './environments/environment';
import packageInfo from '../package.json';
import { registerLocaleData } from '@angular/common';
import localePt from '@angular/common/locales/pt';

registerLocaleData(localePt, 'pt-BR');

if (environment.production) {
  Sentry.init({
    dsn: 'https://f17efc5331ba554997877ecdb6071cee@sentry.ftwmasters.com/32',
    sendDefaultPii: true,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: false,
        maskAllInputs: false,
        networkDetailAllowUrls: ['localhost', /^https:\/\/api\.backoffice\.fsbr\.qualitylabs\.com\.br/],
      }),
      Sentry.feedbackIntegration({
        colorScheme: 'system',
        isNameRequired: true,
        isEmailRequired: true,
      }),
    ],
    // Tracing
    tracesSampleRate: 0.1,
    replaysSessionSampleRate: 0.0,
    replaysOnErrorSampleRate: 1.0,
    tracePropagationTargets: ['localhost', /^https:\/\/api\.backoffice\.fsbr\.qualitylabs\.com\.br/],
    environment: environment.name,
    release: `fastshop.backoffice.frontend@${packageInfo.version}`,
    enabled: environment.production
  });
}

bootstrapApplication(App, appConfig)
  .catch((err) => console.error(err));
